"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DRIPPING_LEARN_MORE_LINK = exports.EndpointErrors = exports.INITIAL_FIELDS = exports.DrippingEndpointKeys = void 0;
const types_1 = require("./types");
var DrippingEndpointKeys;
(function (DrippingEndpointKeys) {
    DrippingEndpointKeys["RemoveBulk"] = "dripping.remove.bulk";
    DrippingEndpointKeys["PostBulk"] = "dripping.post.bulk";
    DrippingEndpointKeys["GetPageClasses"] = "dripping.get.page.classes";
    DrippingEndpointKeys["GetModuleClasses"] = "dripping.get.module.classes";
    DrippingEndpointKeys["GetProductClasses"] = "dripping.get.product.classes";
    DrippingEndpointKeys["GetQuizzes"] = "dripping.get.quizzes";
    DrippingEndpointKeys["GetQuizDetails"] = "dripping.get.quiz_details";
})(DrippingEndpointKeys || (exports.DrippingEndpointKeys = DrippingEndpointKeys = {}));
exports.INITIAL_FIELDS = {
    numberOfDays: null,
    releaseDateTimeISO: null,
    releaseDrippingType: types_1.ReleaseDrippingTypes.None,
    classType: null,
    selectedClasses: [],
    drippingId: null,
    switchEnabled: false,
    quizId: null
};
var EndpointErrors;
(function (EndpointErrors) {
    EndpointErrors["AnotherDrippingBulkOperationInProgress"] = "0054";
    EndpointErrors["InvalidContentType"] = "0006";
})(EndpointErrors || (exports.EndpointErrors = EndpointErrors = {}));
exports.DRIPPING_LEARN_MORE_LINK = 'https://help.hotmart.com/article/213467588/how-to-set-up-a-drip-schedule-and-expiration-date-for-content-in-hotmart-club-';
